export default "__VITE_ASSET__BGxgNU93__"